import { createFileRoute } from '@tanstack/react-router'
import { LeaseContractDialog } from '@/features/end-of-lease/lease-contract-dialog';

export const Route = createFileRoute('/lease/add-contract')({
    component: LeaseAddContractPage,
});

function LeaseAddContractPage() {
    return (
        <main
            className="flex min-h-screen flex-col items-center justify-center p-6 bg-gray-50"
            data-testid="LeaseAddContract"
        >
            <div className="w-xl">
                <LeaseContractDialog />
            </div>
        </main>
    );
}
